export default __webpack_public_path__ + "static/media/settings_integration_preview.60651543.png";